<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<!-- @if (priorityLoad || isBrowser) { -->
<img
    fill
    [ngSrc]="imageUrl()"
    [loaderParams]="loaderParams"
    [alt]="imageModel().alt"
    [sizes]="imageModel().widthVW"
    [priority]="priorityLoad"
    (load)="onImageLoad($event)"
    (error)="onImageError($event)"
    [attr.imageIndex]="imageModel().imageIndex"
    imageChange
/>
<!-- } -->

@defer (when imageModel().showWaterMark && configShowWaterMark; prefetch on idle) {
    <watermark></watermark>
}
